<template>
  <b-input-group size="md" prepend="">
    <template #prepend>
      <b-button class="square">
        <img :src="getImg" alt="" />
      </b-button>
    </template>
    <b-form-select
      v-model="value"
      :options="options"
      class="form-control default"
    ></b-form-select>
  </b-input-group>
</template>
<script>
export default {
  props: {
    defaultValue: {
      type: String,
      required: false,
      default: undefined
    }
  },
  data() {
    return {
      options: [
        {
          text: "Português - BR",
          value: "pt_BR",
        },
      ],
      countries: {
        "pt_BR": require("@/assets/img/countries/br.svg"),
      },
      value: this.defaultValue,
    };
  },
  computed: {
    getImg() {
      return this.countries[this.value] ?? undefined;
    },
  },
  watch:{
    value: { 
      immediate: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  }
};
</script>

<style lang="scss">

</style>